const DB_NAME = 'PsicoPlannerRecordings';
const DB_VERSION = 1;
const META_STORE = 'recordings';
const CHUNK_STORE = 'chunks';

function openDatabase() {
  return new Promise((resolve, reject) => {
    if (!window.indexedDB) {
      reject(new Error('IndexedDB não suportado neste navegador.'));
      return;
    }

    const request = indexedDB.open(DB_NAME, DB_VERSION);

    request.onupgradeneeded = (event) => {
      const db = event.target.result;
      if (!db.objectStoreNames.contains(META_STORE)) {
        db.createObjectStore(META_STORE, { keyPath: 'session_id' });
      }
      if (!db.objectStoreNames.contains(CHUNK_STORE)) {
        const chunkStore = db.createObjectStore(CHUNK_STORE, { keyPath: 'id', autoIncrement: true });
        chunkStore.createIndex('session_id', 'session_id', { unique: false });
      }
    };

    request.onsuccess = (event) => resolve(event.target.result);
    request.onerror = () => reject(request.error);
  });
}

function promisifyRequest(request) {
  return new Promise((resolve, reject) => {
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}

function promisifyTx(tx) {
  return new Promise((resolve, reject) => {
    tx.oncomplete = () => resolve();
    tx.onerror = () => reject(tx.error);
    tx.onabort = () => reject(tx.error);
  });
}

export default {
  async saveMeta(sessionId, meta) {
    const db = await openDatabase();
    const tx = db.transaction(META_STORE, 'readwrite');
    tx.objectStore(META_STORE).put({ ...meta, session_id: sessionId });
    await promisifyTx(tx);
  },

  async getMeta(sessionId) {
    const db = await openDatabase();
    const tx = db.transaction(META_STORE, 'readonly');
    const result = await promisifyRequest(tx.objectStore(META_STORE).get(sessionId));
    return result || null;
  },

  async getAllMeta() {
    const db = await openDatabase();
    const tx = db.transaction(META_STORE, 'readonly');
    const result = await promisifyRequest(tx.objectStore(META_STORE).getAll());
    return result || [];
  },

  async appendChunk(sessionId, seq, blob) {
    const db = await openDatabase();
    const tx = db.transaction(CHUNK_STORE, 'readwrite');
    tx.objectStore(CHUNK_STORE).add({ session_id: sessionId, seq, blob });
    await promisifyTx(tx);
  },

  async reassembleBlob(sessionId, mimeType) {
    const db = await openDatabase();
    const tx = db.transaction(CHUNK_STORE, 'readonly');
    const index = tx.objectStore(CHUNK_STORE).index('session_id');
    const rows = await promisifyRequest(index.getAll(IDBKeyRange.only(sessionId)));
    const ordered = rows.sort((a, b) => a.seq - b.seq);
    return new Blob(ordered.map((row) => row.blob), { type: mimeType });
  },

  async remove(sessionId) {
    const db = await openDatabase();
    const tx = db.transaction([META_STORE, CHUNK_STORE], 'readwrite');
    tx.objectStore(META_STORE).delete(sessionId);

    const chunkStore = tx.objectStore(CHUNK_STORE);
    const cursorRequest = chunkStore.index('session_id').openKeyCursor(IDBKeyRange.only(sessionId));
    cursorRequest.onsuccess = (event) => {
      const cursor = event.target.result;
      if (cursor) {
        chunkStore.delete(cursor.primaryKey);
        cursor.continue();
      }
    };

    await promisifyTx(tx);
  },
};
